import styled from 'styled-components';

import TimelineBase from 'components/Timeline';

export const Timeline = styled(TimelineBase)`
  padding: ${({ theme }) => theme.spacings.abs24}px 0;
`;
